export const CONTACT = {
  salesName: 'Junius',
  whatsappNumber: '6281286864825',
  phone: '+6281286864825',
  phoneDisplay: '+62 812-8686-4825',
  email: 'Juniushukky@gmail.com',
};

export const FLEET_CAMPAIGN = {
  enabled: true,
  path: '/fleet',
  defaultMessage:
    'Halo, saya ingin mendapatkan informasi mengenai program/pembelian fleet BYD untuk perusahaan.',
};

export function createWhatsAppUrl(message = FLEET_CAMPAIGN.defaultMessage) {
  return `https://api.whatsapp.com/send?phone=${CONTACT.whatsappNumber}&text=${encodeURIComponent(message)}`;
}

